<template>
  <scrollactive
    class="quick-menu-bar theme-group-2"
    aria-label="Categories"
    :offset="160"
    :scroll-offset="140"
    :duration="300"
    :highlight-first-item="true"
    active-class="active-link"
    @itemchanged="onItemChanged"
  >
    <div class="quick-menu-bar__categories-container">
      <category-link v-for="(category, index) in menu" :key="index" class="category" :category="category.displayName" />
    </div>
    <hr class="quick-menu-bar__divider" />
  </scrollactive>
</template>

<script>
import QuickMenuMixin from "../quick-menu/templates/quick-menu.mixin";
import CategoryLink from "../quick-menu/category-link/CategoryLink";
import { isElementHideToTheLeft, isElementHideToTheRight, scrollMenuToshowElementAlignedToTheRight } from "../../../../utils";

export default {
  name: "QuickMenuBar",
  components: { CategoryLink },
  mixins: [QuickMenuMixin],
  methods: {
    onItemChanged(event, currentItem) {
      if (!!event && !!currentItem) {
        if (isElementHideToTheLeft(currentItem) || isElementHideToTheRight(currentItem)) {
          scrollMenuToshowElementAlignedToTheRight(currentItem);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.quick-menu-bar {
  width: 100%;
  max-width: $max-width-desktop;
  right: 0;
  position: sticky;
  top: $headerMobileHeight;
  z-index: 1;
  min-height: auto;

  @include respond-to-mobile {
    width: 100%;
    max-width: $max-width-desktop;
  }

  &__categories-container {
    overflow-x: auto;
    display: flex;
    padding-left: ($spacer * 1.75);

    @include respond-to-mobile {
      padding-left: ($spacer * 1.5);
    }
  }

  &__divider {
    height: 1px;
    background-color: $group-2-color-2;
    margin-top: 0px;
    margin-bottom: 0px;
    opacity: 0.1;
    max-width: #{$max-width-desktop - ($spacer * 1.5)};
    margin-left: ($spacer * 0.75);
    margin-right: ($spacer * 0.75);
    border: 0px;

    @include respond-to-mobile {
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.quick-menu-link {
  @include app-link;
  box-sizing: border-box;
  display: inline-block;
  height: 48px;
  margin-right: ($spacer * 2);
  outline: none;
  white-space: nowrap;

  &.active-link {
    font-weight: $font_bold;
    border-color: $group-2-color-3 !important;
  }

  &.category-link {
    padding: 12px 0 $spacer 0;
    border-radius: 0;
    background-color: transparent;
    font-size: 14px;
    @include respond-to-mobile {
      padding: 12px 0 17px 0;
    }
  }

  &.category-link:not(.expanded) {
    border: none;
    border-bottom: 3px solid transparent;
  }

  &:hover {
    text-decoration: none;
  }
}
</style>
